export default "__VITE_ASSET__18026946__"